import ClockInOutCard from "./components/clock-in-out-card/ClockInOutCard"
import Birthday from "./components/birthday/Birthday"
import Notes from "./components/notes/Notes"
import AttendanceTable from "../../components/attendance-table/AttendanceTable"


function Home() {
  return (
    <section className="px-2">
      <div className="grid m-0 p-0">
        <div className="col-12 md:col-9 grid m-0 p-0">
          <div className="col-12 grid m-0 p-0">
            <div className="col-12 md:col-7">
              <ClockInOutCard />
            </div>
            <div className="col-12 md:col-5">
              <Birthday />
            </div>
          </div>
          <div className="col-12">
            <AttendanceTable />
          </div>
        </div>
        <div className="col-12 md:col-3">
          <Notes />
        </div>
      </div>

    </section>
  )
}

export default Home